var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.426398 3.36842C0.426398 2.43826 1.18044 1.68421 2.11061 1.68421H13.9001C14.8302 1.68421 15.5843 2.43826 15.5843 3.36842V14.3158C15.5843 15.246 14.8302 16 13.9001 16H2.11061C1.18044 16 0.426398 15.246 0.426398 14.3158V3.36842ZM13.9001 3.36842H2.11061V14.3158H13.9001V3.36842Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47903 0C5.94411 1.00387e-07 6.32114 0.377024 6.32114 0.842105L6.32114 4.21053C6.32114 4.67561 5.94411 5.05263 5.47903 5.05263C5.01395 5.05263 4.63692 4.67561 4.63692 4.21053L4.63693 0.842105C4.63693 0.377023 5.01395 -1.00387e-07 5.47903 0Z",
    fill: "#21272F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.414062 6.73684C0.414062 6.27176 0.791086 5.89474 1.25617 5.89474H14.7093C15.1744 5.89474 15.5514 6.27176 15.5514 6.73684C15.5514 7.20192 15.1744 7.57895 14.7093 7.57895H1.25617C0.791086 7.57895 0.414062 7.20192 0.414062 6.73684Z",
    fill: "#21272F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5317 0C10.9967 1.00387e-07 11.3738 0.377024 11.3738 0.842105V4.21053C11.3738 4.67561 10.9967 5.05263 10.5317 5.05263C10.0666 5.05263 9.68956 4.67561 9.68956 4.21053L9.68956 0.842105C9.68956 0.377023 10.0666 -1.00387e-07 10.5317 0Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderBlackIcon);
export default __webpack_public_path__ + "static/media/calender-black-icon.9ddd698a0ef133cb6e3f2f80f0aa6373.svg";
export { ForwardRef as ReactComponent };